'use strict'

const BaseAnalyticsBuilder = require('./baseAnalyticsBuilder');
const CONSTANTS = require('../constants/constants');
const PaymentEventHelper = require('../helpers/paymentEventHelper');

class CartAnalyticsBuilder extends BaseAnalyticsBuilder {

  constructor() {
    super();
    this.cartViewEventUrl = $('body .js-ga4-dataset').data('viewevent');
    //Get all page elements who are useful for Google Analytics
  }

  /**
   * This function will attach analytics events to current page
   */
  attachAnalytics() {
    //Attach base events
    super.attachAnalytics();

    //Attach specific events
    this.attachSpecificTriggers();

    $('.js-cart').on(CONSTANTS.EVENT_CONSTANTS.CART.EVENTS.MINICART_EXPRESS, PaymentEventHelper.clickPayPalExpress);
  }

  /**
   * This function exposes triggers to element inside current page
   */
  attachSpecificTriggers() {
    viewCartEvent(this.cartViewEventUrl);
    $('#update-cart').on('click', updateCartEvent); //UPDATE CART EVENT
    $('.cart-item-actions .button-text').first().on(CONSTANTS.EVENT_CONSTANTS.CART.EVENTS.REMOVE_PRODUCT, updateCartEvent); //DELETE FROM CART EVENT
  }
}

/**
 * Event functions
 */

/**
 * Update cart event
 * @param event
 */
async function updateCartEvent(event, data) {

  if (typeof dataLayer != 'undefined') {

    let updateForm = $('#cart-items-form-wrap');
    let url;

    if (data.hasOwnProperty('increase')) {
      url = updateForm.data('url') + '?isincrease=' + data.increase;
      if (data.pid) url += '&removepid=' + data.pid;
    }

    if (data.hasOwnProperty('action') && data.hasOwnProperty('pid')) {
      url = updateForm.data('url') + '?action=' + data.action + '&removepid=' + data.pid;
    }

    if (!data.hasOwnProperty('removeFullProduct')) {
      url += '&removeFullProduct=' + false;
    }

    if (data.hasOwnProperty('analyticsData')) {
      dataLayer.push({
        event: data.analyticsData.event,
        ecommerce: data.analyticsData.ecommerce
      });

      return;
    }

    let csrf_token = await csrf.methods.getCsrfToken();

    //STEP 1 -- Update cart
    $.ajax({
      type: 'POST',
      url: url,
      data: { csrf_token: csrf_token.token },
      success: function (data) {
        //STEP 1: Check data existence
        if (!data || !data.analyticsData) {
          console.error('Cart update analytics failed');
          return;
        }

        //STEP 2: Build and push data to analytics
        dataLayer.push({
          event: data.analyticsData.event,
          ecommerce: data.analyticsData.ecommerce
        });
      },
    })
  }

}


/**
 * View cart event
 * @param event
 */
function viewCartEvent(url) {

  if (typeof dataLayer != 'undefined') {

    // event.preventDefault();

    //STEP 1: Update cart
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) {
        //STEP 1: Check data existence
        if (!data || !data.eventData) {
          console.error('Cart view analytics failed');
          return;
        }

        //STEP 2: Build and push data to analytics
        dataLayer.push({
          event: CONSTANTS.EVENT_LIST_NAME.VIEW_CART,
          ecommerce: data.eventData
        });
      },
    });
  }
}

module.exports = CartAnalyticsBuilder;
